export default __webpack_public_path__ + "static/media/change_course_chevron.53926d13.svg";